import { isWeb } from '@/constants/environment'
import { Item } from '@/features/pos/components/ProductCatalog/parts/ProductList/types'
import { useFocusEffect } from '@react-navigation/native'
import { FlashList } from '@shopify/flash-list'
import { RefObject, useCallback } from 'react'

export const useRefreshOnFocus = (
    ref: RefObject<FlashList<Item> | null>,
    disabled: boolean
): void => {
    useFocusEffect(
        useCallback(() => {
            if (!isWeb) return

            if (disabled) return

            ref.current?.forceUpdate()

            return () => {
                ref.current?.clearLayoutCacheOnUpdate()
            }
        }, [disabled, ref])
    )
}
